import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import {
  DataGranularity,
  DeviceType,
  FilterType,
  HTTPValidationError,
  HttpResponse,
  OrderSourceType,
  SeriesValue,
} from '@/api/dashboard'
import { makeRevenueByDeviceDatesDemoData } from '@/layouts/dashboard/demo_data'

type Query = {
  /**
   * Tz
   * @default 0
   */
  tz?: number

  type?: FilterType

  start_at?: number

  end_at?: number

  granularity?: DataGranularity

  order_source?: OrderSourceType

  device_type?: DeviceType

  countries?: string
}

export const useRevenueByDeviceQuery = (
  companyId: string,
  gameId: string,
  query: Query,
  enabled = true,
  demoSelectedFilter = '7',
) => {
  return useQuery({
    queryKey: [
      'revenue_by_device',
      companyId,
      gameId,
      query,
      gameId == import.meta.env.VITE_DEMO_GAME_ID ? demoSelectedFilter : '',
    ],
    queryFn: ({ signal }) => {
      if (gameId == import.meta.env.VITE_DEMO_GAME_ID) {
        return new Promise(resolve => {
          resolve({
            data: makeRevenueByDeviceDatesDemoData(demoSelectedFilter),
          })
        }) as unknown as Promise<HttpResponse<SeriesValue[], HTTPValidationError>>
      }
      return dashboardClient.v1.getRevenueByDateDevice({ companyId, gameId, ...query }, { signal })
    },
    select: response => response.data,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    refetchOnMount: false,
    enabled,
  })
}
